'use client';
import { useState, useEffect } from "react";
import Image from "next/image";
import Link from "next/link";
import styles from "./TeamGrid.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLinkedinIn } from "@fortawesome/free-brands-svg-icons";
import { motion, AnimatePresence } from "framer-motion";

const TeamGridList = (props) => {
    const { initialItems, members, hostCms, locale } = props;
    const [visibleItems, setVisibleItems] = useState(initialItems ?? 11);
    const [itemsAdded, setItemsAdded] = useState(0);
    const [width, setWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 0);

    useEffect(() => {
        updateVisibleItems();

        const handleResize = () => {
            setWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [initialItems]);

    useEffect(() => {
        updateVisibleItems();
    }, [width]);

    const updateVisibleItems = () => {
        let itemsToShow;
        if (width < 768) {
            itemsToShow = 3;
        } else if (width < 1400) {
            itemsToShow = 4;
        } else {
            itemsToShow = 4;
        }
        const adjustedInitialItems = adjustInitialItems(initialItems, itemsToShow);
        setVisibleItems(adjustedInitialItems);
        setItemsAdded((prevValue) => prevValue + adjustedInitialItems);
    };

    const adjustInitialItems = (number, divisor) => {
        if (width < 1400) {
            if (number % divisor !== 0) {
                return number - 1;
            }
        }
        return number;
    };

    const showMoreItems = () => {
        const itemsHidden = members.length - visibleItems;
        const showItems = itemsHidden < 4 ? itemsHidden : 4;
        setVisibleItems((prevValue) => prevValue + showItems);
        setItemsAdded((prevValue) => prevValue + showItems);
    };

    const showLessItems = () => {
        if (width < 1400) {
            setVisibleItems(initialItems - 1);
        } else {
            setVisibleItems(initialItems ?? 11);
        }

        setItemsAdded(0);
    };

    const toggleItems = () => {
        if (visibleItems < members.length) {
            showMoreItems();
        } else {
            showLessItems();
        }
    };



    return (
        <>
            <div className={styles.gridTeam}>
                <AnimatePresence>
                    {members.map((item, index) => (
                        index < visibleItems && (
                            <motion.article
                                key={index}
                                initial={index >= initialItems ? { opacity: 0, height: 0, translateY: -100 } : {}}
                                animate={{ opacity: 1, height: '400px', translateY: 0 }}
                                exit={{ opacity: 0, height: 0, translateY: -100 }}
                                transition={{ duration: 0.5 }}
                                className={`${styles.gridTeam__item}`}
                            >
                                <figure className={styles.gridTeam__item__figure}>
                                    <Image
                                        src={hostCms + item.image_member.data?.attributes.url}
                                        alt={item.title_member}
                                        width={300}
                                        height={300}
                                        priority
                                        quality={100}
                                        unoptimized={true}
                                    />
                                </figure>
                                <div className="grid-team__item__details">
                                    <h4>{item.title_member}</h4>
                                    <div className={styles.gridTeam__item__foot}>
                                        <p>{item.speciality_memeber}</p>
                                        <Link
                                            target="_blank"
                                            href={item.linkedin_member ?? '#'}
                                        >
                                            <FontAwesomeIcon icon={faLinkedinIn} />
                                        </Link>
                                    </div>
                                </div>
                            </motion.article>
                        )
                    ))}
                </AnimatePresence>
            </div>

            {members.length > initialItems && (
                <div className="container buttonContent d-flex justify-content-center mt-xl">
                    <button
                        id="showMore"
                        type="button"
                        onClick={toggleItems}
                        className={`evanhub-btn btn-outline__primary mx-w-fit ${styles.buttonShow}`}
                    >
                        {visibleItems < members.length ? (locale == 'es' ? 'Ver más profesionales' : 'See more professionals') : (locale == 'es' ? 'Ver menos profesionales' : 'See less professionals')}
                        <i className={`bi ${visibleItems < members.length ? 'bi-chevron-down' : 'bi-chevron-up'}`} ></i>
                    </button>
                </div>
            )}
        </>
    );
};

export default TeamGridList;
